export default __webpack_public_path__ + "assets/front/scss/user-profile.fb54fb1a49cf8efc4fffe42de997fcfd.css";